module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-8a1f2d7b.png";